import React, { useState, useEffect, useRef } from "react";
import { makeStyles, Button, Grid, TextField } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import closeSvg from "../../assets/svg/delete.svg";
import {
  fetchEmailCode,
  resetPasswordByPasswordAndEmailCode,
} from "../../actions/password";

const useStyles = makeStyles({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: (width) => {
      return width + "px";
    },
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  title: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e9e9e9",
    fontSize: "16px !important",
    color: "#666",
    boxSizing: "border-box",
    "& img": {
      cursor: "pointer",
    },
  },
  content: {
    width: "100%",
    padding: "18px 30px 20px 30px",
    boxSizing: "border-box",
  },
  input: {
    flex: "1",
    "& input": {
      height: "40px",
      padding: "0 15px",
      border: "1px solid #d9d9d9",
      fontSize: "16px",
      color: "#000",
      boxSizing: "border-box",
      borderRadius: "2px",
      outline: "none",
      "&::-webkit-input-placeholder": {
        color: "#999",
      },
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      bottom: "-24px",
      margin: "0 !important",
    },
  },
  formItem: {
    width: "100%",
    marginBottom: "24px !important",
    display: "flex",
    flexFlow: "row",
    flexDirection: "row !important",
    alignItems: "center",
    "& label": {
      width: "84px",
      textAlign: "right",
    },
  },
  footer: {
    padding: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderTop: "1px solid #ddd",
  },
  btn: {
    width: "82px",
    height: "34px",
    marginLeft: "14px",
    borderRadius: "2px",
    background: "#3276C3",
    "&.small": {
      fontSize: "12px",
      padding: "0 !important",
    },
  },
  defaultBtn: {
    width: "82px",
    height: "34px",
    padding: "0 !important",
    border: "1px solid #d9d9d9 !important",
    borderRadius: "2px",
    backgroundColor: "#fff !important",
    color: "rgba(0, 0, 0, .65) !important",
    fontSize: "14px",
    boxShadow: "none !important",
    "&.first": {
      marginRight: "10px",
    },
  },
});
export default function EmailModal(props) {
  const { submit, close, width, username } = props;
  const classes = useStyles(width);
  const [downTime, setDownTime] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("邮箱地址错误");
  const [codeErrorMessage, setCodeErrorMessage] = useState("验证码格式错误");

  const [form, setForm] = useState({
    email: "",
    code: "",
    password: "",
  });

  const [waiting, setWaiting] = useState(false);

  const [formError, setFormError] = useState({
    error1: false,
    error2: false,
    error3: false,
  });

  useEffect(() => {}, []);

  const inputRef = useRef();

  const changeInput = (e) => {
    let newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;
    setForm(newForm);
  };

  const emailBlur = (e) => {
    setEmailErrorMessage("邮箱地址错误");
    let newFormError = Object.assign({}, formError);
    newFormError.error1 =
      !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
        e.target.value
      );
    setFormError(newFormError);
  };

  const codeBlur = (e) => {
    setCodeErrorMessage("验证码格式错误");
    let newFormError = Object.assign({}, formError);
    newFormError.error2 = !/^\d{6}$/.test(e.target.value);
    setFormError(newFormError);
  };

  const passwordBlur = (e) => {
    let newFormError = Object.assign({}, formError);
    newFormError.error3 = e.target.value.length > 5 ? false : true;
    setFormError(newFormError);
  };

  const inputFocus = (e, key) => {
    let newFormError = Object.assign({}, formError);
    newFormError[key] = false;
    setFormError(newFormError);
  };

  const confirm = () => {
    let newFormError = Object.assign({}, formError);
    let errorFlag = false;
    if (!form.email) {
      newFormError.error1 = true;
      errorFlag = true;
    }
    if (!form.code) {
      newFormError.error2 = true;
      errorFlag = true;
    }
    if (form.password == "") {
      newFormError.error3 = true;
      errorFlag = true;
    }
    setFormError(newFormError);
    if (errorFlag) {
      return;
    }
    submitModifyEmail();
  };

  const submitModifyEmail = () => {
    let email = form.email;
    let code = form.code;
    let password = form.password;
    let data = { username, email, code, password };
    resetPasswordByPasswordAndEmailCode(data)
      .then(() => {
        submit();
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response.data);
        let newFormError = Object.assign({}, formError);
        if (
          err.response.data.mobile == "user with this email already exists."
        ) {
          setEmailErrorMessage("该邮箱地址码已经存在！");
          newFormError.error1 = true;
          setFormError(newFormError);
        }
        if (err.response.data.non_field_errors == "无效的验证码") {
          setCodeErrorMessage("无效的验证码");
          newFormError.error2 = true;
          setFormError(newFormError);
        }
        if (err.response.data.non_field_errors == "验证码错误") {
          setCodeErrorMessage("验证码错误");
          newFormError.error2 = true;
          setFormError(newFormError);
        }
        if (err.response.data[0] == "原密码不正确") {
          newFormError.error3 = true;
          setFormError(newFormError);
        }
      });
  };

  const sendCode = () => {
    //发送验证码
    let newFormError = Object.assign({}, formError);

    if (form.email == "" || newFormError.error1) {
      newFormError.error1 = true;
      return;
    }
    let email = form.email;
    let data = { username, email };
    fetchEmailCode(data);
    setWaiting(true);
    //倒计时
    countDown(60);
    setTimeout(() => {
      setWaiting(false);
    }, 60000);
  };

  const countDown = (time) => {
    time--;
    setDownTime(time);
    if (time > 0) {
      setTimeout(() => {
        countDown(time);
      }, 1000);
    }
  };

  return (
    <Grid className={classes.box}>
      <Typography className={classes.title}>
        <Typography variant="span">修改邮箱地址</Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg} />
        </Typography>
      </Typography>

      <Grid className={classes.content}>
        <Grid className={classes.form}>
          <FormControl className={classes.formItem}>
            <FormLabel id="emailLabel">邮箱地址：</FormLabel>
            <TextField
              error={formError.error1}
              helperText={formError.error1 ? emailErrorMessage : ""}
              placeholder="请输入邮箱地址"
              aria-labelledby="emailLabel"
              name="email"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onBlur={emailBlur}
              onFocus={(e) => inputFocus(e, "error1")}
            />
          </FormControl>
          <FormControl className={classes.formItem}>
            <FormLabel id="codeLabel">验证码：</FormLabel>
            <TextField
              error={formError.error2}
              helperText={formError.error2 ? codeErrorMessage : ""}
              placeholder="请输入验证码"
              aria-labelledby="codeLabel"
              name="code"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onBlur={codeBlur}
              onFocus={(e) => inputFocus(e, "error2")}
            />
            <Button
              onClick={sendCode}
              className={[classes.btn, "small"].join(" ")}
              variant="contained"
              color="primary"
              disabled={waiting}
            >
              {" "}
              {downTime || "发送验证码"}
            </Button>
          </FormControl>
          <FormControl className={classes.formItem}>
            <FormLabel id="passwordLabel">登录密码：</FormLabel>
            <TextField
              type="password"
              error={formError.error3}
              helperText={formError.error3 ? "密码错误" : ""}
              placeholder="请输入登录密码"
              aria-labelledby="passwordLabel"
              name="password"
              className={classes.input}
              variant="outlined"
              onChange={changeInput}
              onBlur={passwordBlur}
              onFocus={(e) => inputFocus(e, "error3")}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid className={classes.footer}>
        <Button
          onClick={close}
          className={classes.defaultBtn}
          variant="contained"
        >
          {" "}
          取消
        </Button>
        <Button
          onClick={confirm}
          className={classes.btn}
          variant="contained"
          color="primary"
          disabled={formError.error1 || formError.error2 || formError.error3}
        >
          {" "}
          修改
        </Button>
      </Grid>
    </Grid>
  );
}
